export default "__VITE_ASSET__a8dcf47d__"